import { updateAppUrl } from 'lib/url/route'
import parse from 'lib/url/parse'
import { objectToQueryString } from 'lib/helpers'
import { DEFAULT_APP } from './constants'
// TODO: define enum type for all section values that can be called here
export const updateTradeUrl = (href: string, section: string): void => {
  const { query } = parse(href) || {}
  const app = `${DEFAULT_APP}?${objectToQueryString({
    section,
    ...query,
  })}`
  updateAppUrl({
    app,
    href,
  })
}